<quick-card
  [routerLink]="['./tenants']"
  [uid]="'tenants-card'"
  [heading]="'Tenants*'"
  [headingColor]="'accent'"
  [loader]="loader"
  [hasRouterOutlet]="true"
  [headingIconKey]="'home_work'"
  [innerContentTemplate]="results"
  [matTooltip]="'Manage tenants, available to system users only'"
></quick-card>

<ng-template #results let-content=content>
  {{content['countTotal']}}
</ng-template>
